import { ApiService } from '../../services/api_service';
import * as config from '../../wips.config.js';
import { DatenauswertungFormWrapper } from './DatenauswertungFormWrapper';
import { DatenauswertungGenerisch } from './DatenauswertungGenerisch';
import { DatenauswertungJahrauswahl } from './DatenauswertungJahrauswahl';
import { DatenauswertungReportKonfigurationBemerkungButton } from './DatenauswertungReportKonfigurationBemerkungButton';
import datenauswertungStyle from './datenauswertung.less'
import { disableKosten } from '../../helpers/showKosten';
import { fn0nZ, fn2, fn2nZ } from '../../core/formatter/formatNumber';
import { getRoutingEnergiedaten } from '../../helpers/getRoutingEnergiedaten';
import { getStandorteGruppenTabRoutings } from '../dateneingabe/functions/StandorteGruppen';
import { i18n } from '../../i18n/i18n';
import { IDs } from '../../helpers/IDs';
import { isVeranstaltung } from '../../helpers/getVeranstaltungen';
import { KennzahlenInfo } from './elements/KennzahlenInfo';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { rowHasValues } from './generisch/renderRows';
import { SectionStyle } from '../../helpers/SectionStyle';
import { StandortAuswahl } from './elements/StandortAuswahl';
import { Validierung } from './elements/Validierung';
import { ValidierungHinweise } from './elements/ValidierungHinweise';
import { WActionButton } from '../../core/elements/WActionButton';
import { WHelpIcon } from '../../core/elements/WHelpIcon';

interface DatenauswertungKraftstoffeProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
    standortTid: number;
    standortName: string;
    jahrFirst?: number;
    jahrLast?: number;
    setJSXdirect?: (content: JSX.Element) => void;
    callbackPages?: (pageNumber: number, totalPages: number) => void;
}

interface DatenauswertungKraftstoffeState {
    pdfString?: string;
    firstJahr: number;
    lastJahr: number;
    jahrMin: number;
    jahrMax: number;
    renderButton: JSX.Element;
    validation: any;
}

export class DatenauswertungKraftstoffe extends React.Component<DatenauswertungKraftstoffeProps, DatenauswertungKraftstoffeState> {

    constructor(props: any) {
        super(props);
        const data: any = props.data || {};
        const startjahr: number = ((data[IDs.ENT_KONFIGURATION] || [])[0] || {}).startjahr_datenerfassung || null;
        const jahrMax: number = new Date().getFullYear();
        let jahrMin: number = (data.first_year > 2009 && data.first_year < 2015) ? data.first_year : 2015;
        jahrMin = (startjahr > jahrMin) ? startjahr : jahrMin;
        this.state = {
            lastJahr: this.props.jahrLast || jahrMax - 1,
            firstJahr: this.props.jahrFirst || jahrMin,
            jahrMin: jahrMin,
            jahrMax: jahrMax,
            renderButton: undefined,
            validation: {}
        };
    }

    @lazyInject(ApiService) private apiService: ApiService;

    private devFeaturesMap: any = config.devFeaturesMap || {};
    private disableKosten: boolean;
    private entities: any[] = [
        { titel: i18n('Kraftstoffe', 'sys'), entity: IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE }
    ];

    componentDidMount(): void {
        this.disableKosten = disableKosten(this.props.data);
        this.setState({
            validation: new Validierung(
                this.props.data,
                this.props.standortTid,
                this.entities,
                'jahr'
            ).getData()
        });
    }

    getValues(show_decimals: boolean): any {
        const rows: any[] = [];
        const diag1: any[] = [];
        const diag2: any[] = [];
        const custom_row_classes: any[] = [];
        const row_web_forced: boolean[] = [];
        const kennzahlen = this.props.standortTid
            ? this.props.data[IDs.KENNZIFFERN_BERECHNET_STANDORT][this.props.standortTid]
            : this.props.data[IDs.KENNZIFFERN_BERECHNET];

        for (let jahr = this.state.firstJahr; jahr <= this.state.lastJahr; jahr++) {
            const benzin_verbrauch = kennzahlen[jahr] && kennzahlen[jahr].benzin_verbrauch ? kennzahlen[jahr].benzin_verbrauch : 0;
            const diesel_verbrauch = kennzahlen[jahr] && kennzahlen[jahr].diesel_verbrauch ? kennzahlen[jahr].diesel_verbrauch : 0;
            const lpg_verbrauch = kennzahlen[jahr] && kennzahlen[jahr].lpg_verbrauch ? kennzahlen[jahr].lpg_verbrauch : 0;
            const biodiesel_verbrauch = kennzahlen[jahr] && kennzahlen[jahr].biodiesel_verbrauch ? kennzahlen[jahr].biodiesel_verbrauch : 0;
            const bioethanol_verbrauch = kennzahlen[jahr] && kennzahlen[jahr].bioethanol_verbrauch ? kennzahlen[jahr].bioethanol_verbrauch : 0;

            const benzin_kwh = kennzahlen[jahr] && kennzahlen[jahr].benzin_kwh ? kennzahlen[jahr].benzin_kwh : 0;
            const diesel_kwh = kennzahlen[jahr] && kennzahlen[jahr].diesel_kwh ? kennzahlen[jahr].diesel_kwh : 0;
            const lpg_kwh = kennzahlen[jahr] && kennzahlen[jahr].lpg_kwh ? kennzahlen[jahr].lpg_kwh : 0;
            const wasserstoff_kwh = kennzahlen[jahr] && kennzahlen[jahr].wasserstoff_kwh ? kennzahlen[jahr].wasserstoff_kwh : 0;
            const erdgas_kwh = kennzahlen[jahr] && kennzahlen[jahr].erdgas_kraftstoff_kwh ? kennzahlen[jahr].erdgas_kraftstoff_kwh : 0;
            const ladestrom_kwh = kennzahlen[jahr] && kennzahlen[jahr].ladestrom_kwh ? kennzahlen[jahr].ladestrom_kwh : 0;
            const biodiesel_kwh = kennzahlen[jahr] && kennzahlen[jahr].biodiesel_kwh ? kennzahlen[jahr].biodiesel_kwh : 0;
            const bioethanol_kwh = kennzahlen[jahr] && kennzahlen[jahr].bioethanol_kwh ? kennzahlen[jahr].bioethanol_kwh : 0;

            const gesamt_verbrauch = benzin_kwh + diesel_kwh + lpg_kwh + wasserstoff_kwh + erdgas_kwh + ladestrom_kwh + biodiesel_kwh + bioethanol_kwh;
            // console.log(jahr, kennzahlen[jahr], gesamt_verbrauch);

            const benzin_kosten = kennzahlen[jahr] && kennzahlen[jahr].benzin_kosten ? kennzahlen[jahr].benzin_kosten : 0;
            const diesel_kosten = kennzahlen[jahr] && kennzahlen[jahr].diesel_kosten ? kennzahlen[jahr].diesel_kosten : 0;
            const lpg_kosten = kennzahlen[jahr] && kennzahlen[jahr].lpg_kosten ? kennzahlen[jahr].lpg_kosten : 0;
            const wasserstoff_kosten = kennzahlen[jahr] && kennzahlen[jahr].wasserstoff_kosten ? kennzahlen[jahr].wasserstoff_kosten : 0;
            const erdgas_kosten = kennzahlen[jahr] && kennzahlen[jahr].erdgas_kraftstoff_kosten ? kennzahlen[jahr].erdgas_kraftstoff_kosten : 0;
            const ladestrom_kosten = kennzahlen[jahr] && kennzahlen[jahr].ladestrom_kosten ? kennzahlen[jahr].ladestrom_kosten : 0;
            const biodiesel_kosten = kennzahlen[jahr] && kennzahlen[jahr].biodiesel_kosten ? kennzahlen[jahr].biodiesel_kosten : 0;
            const bioethanol_kosten = kennzahlen[jahr] && kennzahlen[jahr].bioethanol_kosten ? kennzahlen[jahr].bioethanol_kosten : 0;

            const gesamt_kosten = benzin_kosten + diesel_kosten + lpg_kosten + erdgas_kosten + wasserstoff_kosten + ladestrom_kosten + biodiesel_kosten + bioethanol_kosten;

            const benzin_preis = benzin_verbrauch > 0 ? benzin_kosten / benzin_verbrauch : 0;
            const diesel_preis = diesel_verbrauch > 0 ? diesel_kosten / diesel_verbrauch : 0;
            const lpg_preis = lpg_verbrauch > 0 ? lpg_kosten / lpg_verbrauch : 0;
            const wasserstoff_preis = wasserstoff_kwh > 0 ? wasserstoff_kosten / wasserstoff_kwh : 0;
            const erdgas_preis = erdgas_kwh > 0 ? erdgas_kosten / erdgas_kwh : 0;
            const ladestrom_preis = ladestrom_kwh > 0 ? ladestrom_kosten / ladestrom_kwh : 0;
            const biodiesel_preis = biodiesel_kwh > 0 ? biodiesel_kosten / biodiesel_kwh : 0;
            const bioethanol_preis = bioethanol_kwh > 0 ? bioethanol_kosten / bioethanol_kwh : 0;

            const co2_kraftstoffe = kennzahlen[jahr] && (kennzahlen[jahr].co2_kraftstoffe || kennzahlen[jahr].co2_kraftstoffe === 0)
                ? kennzahlen[jahr].co2_kraftstoffe
                : null;

            const row = show_decimals ? [
                jahr,
                this.renderKennzahlenInfo(fn0nZ(diesel_verbrauch), jahr, 'diesel_liter', 'verbrauch'),
                this.renderKennzahlenInfo(fn0nZ(diesel_kwh), jahr, 'diesel_kwh', 'verbrauch'),
                this.renderKennzahlenInfo(fn0nZ(benzin_verbrauch), jahr, 'benzin_liter', 'verbrauch'),
                this.renderKennzahlenInfo(fn0nZ(benzin_kwh), jahr, 'benzin_kwh', 'verbrauch'),
                this.renderKennzahlenInfo(fn0nZ(lpg_verbrauch), jahr, 'lpg_liter', 'verbrauch'),
                this.renderKennzahlenInfo(fn0nZ(lpg_kwh), jahr, 'lpg_kwh', 'verbrauch'),
                this.renderKennzahlenInfo(fn0nZ(biodiesel_verbrauch), jahr, 'biodiesel_liter', 'verbrauch'),
                this.renderKennzahlenInfo(fn0nZ(biodiesel_kwh), jahr, 'biodiesel_kwh', 'verbrauch'),
                this.renderKennzahlenInfo(fn0nZ(bioethanol_verbrauch), jahr, 'bioethanol_liter', 'verbrauch'),
                this.renderKennzahlenInfo(fn0nZ(bioethanol_kwh), jahr, 'bioethanol_kwh', 'verbrauch'),
                this.renderKennzahlenInfo(fn0nZ(wasserstoff_kwh), jahr, 'wasserstoff_kwh', 'verbrauch'),
                this.renderKennzahlenInfo(fn0nZ(erdgas_kwh), jahr, 'erdgas_kwh', 'verbrauch'),
                this.renderKennzahlenInfo(fn0nZ(ladestrom_kwh), jahr, 'ladestrom_kwh', 'verbrauch'),
                this.renderKennzahlenInfo(fn0nZ(gesamt_verbrauch), jahr, 'kraftstoffe_gesamt', 'verbrauch'),
                this.renderKennzahlenInfo(fn2nZ(diesel_kosten), jahr, 'diesel_kosten', 'kosten'),
                this.renderKennzahlenInfo(fn2nZ(diesel_preis), jahr, 'diesel_preis', 'preis'),
                this.renderKennzahlenInfo(fn2nZ(benzin_kosten), jahr, 'benzin_kosten', 'kosten'),
                this.renderKennzahlenInfo(fn2nZ(benzin_preis), jahr, 'benzin_preis', 'preis'),
                this.renderKennzahlenInfo(fn2nZ(lpg_kosten), jahr, 'lpg_kosten', 'kosten'),
                this.renderKennzahlenInfo(fn2nZ(lpg_preis), jahr, 'lpg_preis', 'preis'),
                this.renderKennzahlenInfo(fn2nZ(biodiesel_kosten), jahr, 'biodiesel_kosten', 'kosten'),
                this.renderKennzahlenInfo(fn2nZ(biodiesel_preis), jahr, 'biodiesel_preis', 'preis'),
                this.renderKennzahlenInfo(fn2nZ(bioethanol_kosten), jahr, 'bioethanol_kosten', 'kosten'),
                this.renderKennzahlenInfo(fn2nZ(bioethanol_preis), jahr, 'bioethanol_preis', 'preis'),
                this.renderKennzahlenInfo(fn2nZ(wasserstoff_kosten), jahr, 'wasserstoff_kosten', 'kosten'),
                this.renderKennzahlenInfo(fn2nZ(wasserstoff_preis), jahr, 'wasserstoff_preis', 'preis'),
                this.renderKennzahlenInfo(fn2nZ(erdgas_kosten), jahr, 'erdgas_kosten', 'kosten'),
                this.renderKennzahlenInfo(fn2nZ(erdgas_preis), jahr, 'erdgas_preis', 'preis'),
                this.renderKennzahlenInfo(fn2nZ(ladestrom_kosten), jahr, 'ladestrom_kosten', 'kosten'),
                this.renderKennzahlenInfo(fn2nZ(ladestrom_preis), jahr, 'ladestrom_preis', 'preis'),
                this.renderKennzahlenInfo(fn2nZ(gesamt_kosten), jahr, 'kraftstoffe_gesamt_kosten', 'kosten'),
                this.renderKennzahlenInfo(fn2(co2_kraftstoffe), jahr, 'kraftstoffe_gesamt_co2', 'verbrauch')
            ] : [
                jahr,
                this.renderKennzahlenInfo(fn0nZ(diesel_verbrauch), jahr, 'diesel_liter', 'verbrauch'),
                this.renderKennzahlenInfo(fn0nZ(diesel_kwh), jahr, 'diesel_kwh', 'verbrauch'),
                this.renderKennzahlenInfo(fn0nZ(benzin_verbrauch), jahr, 'benzin_liter', 'verbrauch'),
                this.renderKennzahlenInfo(fn0nZ(benzin_kwh), jahr, 'benzin_kwh', 'verbrauch'),
                this.renderKennzahlenInfo(fn0nZ(lpg_verbrauch), jahr, 'lpg_liter', 'verbrauch'),
                this.renderKennzahlenInfo(fn0nZ(lpg_kwh), jahr, 'lpg_kwh', 'verbrauch'),
                this.renderKennzahlenInfo(fn0nZ(biodiesel_verbrauch), jahr, 'biodiesel_liter', 'verbrauch'),
                this.renderKennzahlenInfo(fn0nZ(biodiesel_kwh), jahr, 'biodiesel_kwh', 'verbrauch'),
                this.renderKennzahlenInfo(fn0nZ(bioethanol_verbrauch), jahr, 'bioethanol_liter', 'verbrauch'),
                this.renderKennzahlenInfo(fn0nZ(bioethanol_kwh), jahr, 'bioethanol_kwh', 'verbrauch'),
                this.renderKennzahlenInfo(fn0nZ(wasserstoff_kwh), jahr, 'wasserstoff_kwh', 'verbrauch'),
                this.renderKennzahlenInfo(fn0nZ(erdgas_kwh), jahr, 'erdgas_kwh', 'verbrauch'),
                this.renderKennzahlenInfo(fn0nZ(ladestrom_kwh), jahr, 'ladestrom_kwh', 'verbrauch'),
                this.renderKennzahlenInfo(fn0nZ(gesamt_verbrauch), jahr, 'kraftstoffe_gesamt', 'verbrauch'),
                this.renderKennzahlenInfo(fn0nZ(diesel_kosten), jahr, 'diesel_kosten', 'kosten'),
                this.renderKennzahlenInfo(fn2nZ(diesel_preis), jahr, 'diesel_preis', 'preis'),
                this.renderKennzahlenInfo(fn0nZ(benzin_kosten), jahr, 'benzin_kosten', 'kosten'),
                this.renderKennzahlenInfo(fn2nZ(benzin_preis), jahr, 'benzin_preis', 'preis'),
                this.renderKennzahlenInfo(fn0nZ(lpg_kosten), jahr, 'lpg_kosten', 'kosten'),
                this.renderKennzahlenInfo(fn2nZ(lpg_preis), jahr, 'lpg_preis', 'preis'),
                this.renderKennzahlenInfo(fn0nZ(biodiesel_kosten), jahr, 'biodiesel_kosten', 'kosten'),
                this.renderKennzahlenInfo(fn2nZ(biodiesel_preis), jahr, 'biodiesel_preis', 'preis'),
                this.renderKennzahlenInfo(fn0nZ(bioethanol_kosten), jahr, 'bioethanol_kosten', 'kosten'),
                this.renderKennzahlenInfo(fn2nZ(bioethanol_preis), jahr, 'bioethanol_preis', 'preis'),
                this.renderKennzahlenInfo(fn0nZ(wasserstoff_kosten), jahr, 'wasserstoff_kosten', 'kosten'),
                this.renderKennzahlenInfo(fn2nZ(wasserstoff_preis), jahr, 'wasserstoff_preis', 'preis'),
                this.renderKennzahlenInfo(fn0nZ(erdgas_kosten), jahr, 'erdgas_kosten', 'kosten'),
                this.renderKennzahlenInfo(fn2nZ(erdgas_preis), jahr, 'erdgas_preis', 'preis'),
                this.renderKennzahlenInfo(fn0nZ(ladestrom_kosten), jahr, 'ladestrom_kosten', 'kosten'),
                this.renderKennzahlenInfo(fn2nZ(ladestrom_preis), jahr, 'ladestrom_preis', 'preis'),
                this.renderKennzahlenInfo(fn0nZ(gesamt_kosten), jahr, 'kraftstoffe_gesamt_kosten', 'kosten'),
                this.renderKennzahlenInfo(fn2nZ(co2_kraftstoffe), jahr, 'kraftstoffe_gesamt_co2', 'verbrauch'),
            ];
            if (this.disableKosten) {
                row.splice(15, 17); // Kraftstoffverbrauch (Kosten)
            }
            const row_length: number = row.length;
            const hasValues: boolean = rowHasValues(row);
            const isWebForced: boolean = !!(!hasValues && this.state.validation[jahr]);
            const d1 = {
                jahr, verbrauch: +(gesamt_verbrauch || 0).toFixed(),
                ...(!this.disableKosten && { kosten: gesamt_kosten })
            };
            const d2 = { jahr, emissionen: co2_kraftstoffe };
            rows.push([
                <div data-text={row[0]}>
                    <div>{row[0]}</div>
                    {this.state.validation[jahr] &&
                        <ValidierungHinweise
                            entities={this.entities}
                            id={jahr}
                            showPriorityColors
                            validation={this.state.validation}
                        />
                    }
                </div>,
                ...(!hasValues && this.state.validation[jahr]
                    ? Array.from(Array(row_length - 1), (): void => null)
                    : [...Array(row_length - 1)].map((item: any, index: number) => row[index + 1])
                )
            ]);
            if (hasValues) {
                if (gesamt_verbrauch || (!this.disableKosten && gesamt_kosten)) {
                    diag1.push(d1);
                }
                if (co2_kraftstoffe !== null) {
                    diag2.push(d2);
                }
            }
            custom_row_classes.push(isWebForced ? Array.from(Array(row_length), () => 'row_field') : undefined);
            row_web_forced.push(isWebForced);
        }
        return { rows, diag1, diag2, custom_row_classes, row_web_forced };
    }

    render(): JSX.Element {
        const color: any = SectionStyle.getSectionColors() || {};
        const lineColor = [
            color.datenauswertung || '#4f81bd', color.zusatztools || '#f79646', color.dateneingabe || '#87bd51', '#51bd75', '#5163bd',
            '#9951bd', '#bd5175', '#bd5151'
        ];
        // const style: any = { sub: getStyle('sub') };
        const unternehmen: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).name
            || (this.props.data.RES_MAIN_LOAD_UNTERNEHMEN_SEL || {}).bezeichnung || null;
        let values = this.getValues(true);
        // Prüfen, welche Werte da sind
        let has_benzin = false;
        let has_diesel = false;
        let has_wasserstoff = false;
        let has_erdgas = false;
        let has_lpg = false;
        let has_ladestrom = false;
        let has_biodiesel = false;
        let has_bioethanol = false;
        let count_extra = 0;
        const hasValue = (val: any) => {
            return typeof val === 'string' ? val.trim() !== '' : !!val;
        };
        values.rows.forEach((row: any) => {
            if (hasValue(row[1])) { has_diesel = true; count_extra++; }
            if (hasValue(row[3])) { has_benzin = true; count_extra++; }
            if (hasValue(row[5])) { has_lpg = true; count_extra++; }
            if (hasValue(row[7])) { has_biodiesel = true; count_extra++; }
            if (hasValue(row[9])) { has_bioethanol = true; count_extra++; }
            if (hasValue(row[11])) { has_wasserstoff = true; count_extra++; }
            if (hasValue(row[12])) { has_erdgas = true; count_extra++; }
            if (hasValue(row[13])) { has_ladestrom = true; count_extra++; }
        });
        if (count_extra > 2) {
            values = this.getValues(false);
        }
        // Nochmal durchgehen und die Row splicen
        values.rows.forEach((row: any) => {
            if (!has_ladestrom) { row.splice(29, 2); }
            if (!has_erdgas) { row.splice(27, 2); }
            if (!has_wasserstoff) { row.splice(25, 2); }
            if (!has_bioethanol) { row.splice(23, 2); }
            if (!has_biodiesel) { row.splice(21, 2); }
            if (!has_lpg) { row.splice(19, 2); }
            if (!has_ladestrom) { row.splice(13, 1); }
            if (!has_erdgas) { row.splice(12, 1); }
            if (!has_wasserstoff) { row.splice(11, 1); }
            if (!has_bioethanol) { row.splice(9, 2); }
            if (!has_biodiesel) { row.splice(7, 2); }
            if (!has_lpg) { row.splice(5, 2); }
        });
        let colReduce = 0;
        let block1Reduce = 0;
        let block2Reduce = 0;
        if (!has_ladestrom) { colReduce += this.disableKosten ? 2 : 3; block1Reduce += 1; block2Reduce += 2; }
        if (!has_biodiesel) { colReduce += this.disableKosten ? 2 : 4; block1Reduce += 2; block2Reduce += 2; }
        if (!has_bioethanol) { colReduce += this.disableKosten ? 2 : 4; block1Reduce += 2; block2Reduce += 2; }
        if (!has_erdgas) { colReduce += this.disableKosten ? 2 : 3; block1Reduce += 1; block2Reduce += 2; }
        if (!has_wasserstoff) { colReduce += this.disableKosten ? 2 : 3; block1Reduce += 1; block2Reduce += 2; }
        if (!has_lpg) { colReduce += this.disableKosten ? 2 : 4; block1Reduce += 2; block2Reduce += 2; }
        colReduce += this.disableKosten ? 17 : 0;
        const numCols = 33.5 - colReduce;
        const baseWidth = 100 / numCols; // Bitte immer in Prozent angeben

        let fontFactor = 1;
        if (numCols > 12) { fontFactor = 0.9; }
        if (numCols > 18) { fontFactor = 0.8; }

        const block1ColCnt = 14 - block1Reduce;
        const block2ColCnt = 17 - block2Reduce;

        const stCl = { flex: 'unset', width: `${100 / block1ColCnt}%` };
        const stCl2 = { flex: 'unset', width: `${100 / block2ColCnt}%` };
        const stla = { width: '190%', right: '95%', position: 'relative' };

        const config: any = {
            titel0: unternehmen,
            titel1: i18n('Auswertung Kraftstoffe', 'sys'),
            titel2: this.props.standortName,
            filename: `${i18n('Auswertung', 'sys')}_${i18n('Kraftstoffe', 'sys')}_${this.state.firstJahr}_${this.state.lastJahr}.pdf`,
            report: { data: (this.props.data || {})[IDs.ENT_REPORT] || [], standort: +this.props.standortTid || 0, key: 'kraftstoffe' },
            baseWidth: baseWidth,
            header: {
                title: i18n('Übersicht Berechnung', 'sys'),
                blocks: [
                    {
                        label: i18n('Jahr', 'sys'),
                        width: `${baseWidth}%`
                    },
                    {
                        label: `${i18n('Kraftstoffverbrauch', 'sys')} (${i18n('Energieeinsatz', 'sys')})`,
                        width: `${baseWidth * block1ColCnt}%`,
                        columns: [
                            {
                                label: ' ', label2: i18n('Liter', 'sys'),
                                customStyleColumn: { ...stCl },
                                customStyleLabel2: { borderTop: '1pt solid #fff' }
                            },
                            {
                                label: i18n('Diesel', 'sys'), label2: 'kWh',
                                customStyleColumn: { borderLeft: 0, ...stCl },
                                customStyleLabel: { ...stla },
                                customStyleLabel2: {
                                    borderLeft: '1pt solid white', borderTop: '1pt solid #fff'
                                    // backgroundColor: '#bccae3'
                                    // BackgroundColor spielt hier keine Rolle.
                                    // Aber komischerweise verursacht sie in PDF den Border mal 1px dünner …
                                }
                            },
                            {
                                label: ' ', label2: i18n('Liter', 'sys'),
                                customStyleColumn: { borderLeft: '1pt solid white', ...stCl },
                                customStyleLabel2: { borderTop: '1pt solid #fff', borderRight: 0 }
                            },
                            {
                                label: i18n('Benzin', 'sys'), label2: 'kWh',
                                customStyleColumn: { borderLeft: 0, ...stCl },
                                customStyleLabel: { ...stla },
                                customStyleLabel2: {
                                    borderLeft: '1pt solid white', borderTop: '1pt solid #fff'
                                }
                            },
                            {
                                label: ' ', label2: i18n('Liter', 'sys'),
                                customStyleColumn: { ...stCl },
                                customStyleLabel2: { borderTop: '1pt solid #fff', borderRight: 0 }
                            },
                            {
                                label: 'LPG', label2: 'kWh',
                                customStyleColumn: { borderLeft: 0, ...stCl },
                                customStyleLabel: { ...stla },
                                customStyleLabel2: {
                                    borderLeft: '1pt solid white', borderTop: '1pt solid #fff'
                                }
                            },
                            {
                                label: ' ', label2: i18n('Liter', 'sys'),
                                customStyleColumn: { ...stCl },
                                customStyleLabel2: { borderTop: '1pt solid #fff', borderRight: 0 }
                            },
                            {
                                label: i18n('Biodiesel', 'sys'), label2: 'kWh',
                                customStyleColumn: { borderLeft: 0, ...stCl },
                                customStyleLabel: { ...stla },
                                customStyleLabel2: {
                                    borderLeft: '1pt solid white', borderTop: '1pt solid #fff'
                                }
                            },
                            {
                                label: ' ', label2: i18n('Liter', 'sys'),
                                customStyleColumn: { ...stCl },
                                customStyleLabel2: { borderTop: '1pt solid #fff', borderRight: 0 }
                            },
                            {
                                label: i18n('Bioethanol', 'sys'), label2: 'kWh',
                                customStyleColumn: { borderLeft: 0, ...stCl },
                                customStyleLabel: { ...stla },
                                customStyleLabel2: {
                                    borderLeft: '1pt solid white', borderTop: '1pt solid #fff'
                                }
                            },
                            {
                                label: i18n('Wasserstoff', 'sys'), label2: 'kWh',
                                customStyleColumn: { ...stCl },
                                customStyleLabel2: { borderTop: '1pt solid #fff' }
                            },
                            {
                                label: i18n('Erdgas', 'sys'), label2: 'kWh', customStyleColumn: { ...stCl },
                                customStyleLabel2: { borderTop: '1pt solid #fff' }
                            },
                            {
                                label: i18n('Ladestrom', 'sys'), label2: 'kWh', customStyleColumn: { ...stCl },
                                customStyleLabel2: { borderTop: '1pt solid #fff' }
                            },
                            {
                                label: i18n('Gesamt', 'sys'), label2: 'kWh', customStyleColumn: { ...stCl },
                                customStyleLabel2: { borderTop: '1pt solid #fff' }
                            },
                        ]
                    },
                    {
                        label: `${i18n('Kraftstoffverbrauch', 'sys')} (${i18n('Kosten', 'sys')})`,
                        width: `${baseWidth * block2ColCnt}%`,
                        columns: [
                            {
                                label: ' ', label2: `€ (${i18n('netto', 'sys')})`,
                                customStyleColumn: { ...stCl2 },
                                customStyleLabel2: { borderTop: '1pt solid #fff', borderRight: 0 }
                            },
                            {
                                label: i18n('Diesel', 'sys'), label2: `€/${i18n('Liter', 'sys')}`,
                                customStyleColumn: { borderLeft: 0, ...stCl2 },
                                customStyleLabel: { ...stla },
                                customStyleLabel2: {
                                    borderLeft: '1pt solid white', borderTop: '1pt solid #fff'
                                }
                            },
                            {
                                label: ' ', label2: `€ (${i18n('netto', 'sys')})`,
                                customStyleColumn: { ...stCl2 },
                                customStyleLabel2: { borderTop: '1pt solid #fff', borderRight: 0 }
                            },
                            {
                                label: i18n('Benzin', 'sys'), label2: `€/${i18n('Liter', 'sys')}`,
                                customStyleColumn: { borderLeft: 0, ...stCl2 },
                                customStyleLabel: { ...stla },
                                customStyleLabel2: {
                                    borderLeft: '1pt solid white', borderTop: '1pt solid #fff'
                                }
                            },
                            {
                                label: ' ', label2: `€ (${i18n('netto', 'sys')})`,
                                customStyleColumn: { ...stCl2 },
                                customStyleLabel2: { borderTop: '1pt solid #fff', borderRight: 0 }
                            },
                            {
                                label: 'LPG', label2: `€/${i18n('Liter', 'sys')}`,
                                customStyleColumn: { borderLeft: 0, ...stCl2 },
                                customStyleLabel: { ...stla },
                                customStyleLabel2: {
                                    borderLeft: '1pt solid white', borderTop: '1pt solid #fff'
                                }
                            },
                            {
                                label: ' ', label2: `€ (${i18n('netto', 'sys')})`,
                                customStyleColumn: { ...stCl2 },
                                customStyleLabel2: { borderTop: '1pt solid #fff', borderRight: 0 }
                            },
                            {
                                label: i18n('Biodiesel', 'sys'), label2: '€/kWh',
                                customStyleColumn: { borderLeft: 0, ...stCl2 },
                                customStyleLabel: { ...stla },
                                customStyleLabel2: {
                                    borderLeft: '1pt solid white', borderTop: '1pt solid #fff'
                                }
                            },
                            {
                                label: ' ', label2: `€ (${i18n('netto', 'sys')})`,
                                customStyleColumn: { ...stCl2 },
                                customStyleLabel2: { borderTop: '1pt solid #fff', borderRight: 0 }
                            },
                            {
                                label: i18n('Bioethanol', 'sys'), label2: '€/kWh',
                                customStyleColumn: { borderLeft: 0, ...stCl2 },
                                customStyleLabel: { ...stla },
                                customStyleLabel2: {
                                    borderLeft: '1pt solid white', borderTop: '1pt solid #fff'
                                }
                            },
                            {
                                label: ' ', label2: `€ (${i18n('netto', 'sys')})`,
                                customStyleColumn: { ...stCl2 },
                                customStyleLabel2: { borderTop: '1pt solid #fff', borderRight: 0 }
                            },
                            {
                                label: i18n('Wasserstoff', 'sys'), label2: '€/kWh',
                                customStyleColumn: { borderLeft: 0, ...stCl2 },
                                customStyleLabel: { ...stla },
                                customStyleLabel2: {
                                    borderLeft: '1pt solid white', borderTop: '1pt solid #fff'
                                }
                            },
                            {
                                label: ' ', label2: `€ (${i18n('netto', 'sys')})`,
                                customStyleColumn: { ...stCl2 },
                                customStyleLabel2: { borderTop: '1pt solid #fff', borderRight: 0 }
                            },
                            {
                                label: i18n('Erdgas', 'sys'), label2: '€/kWh',
                                customStyleColumn: { borderLeft: 0, ...stCl2 },
                                customStyleLabel: { ...stla },
                                customStyleLabel2: {
                                    borderLeft: '1pt solid white', borderTop: '1pt solid #fff'
                                }
                            },
                            {
                                label: ' ', label2: `€ (${i18n('netto', 'sys')})`,
                                customStyleColumn: { ...stCl2 },
                                customStyleLabel2: { borderTop: '1pt solid #fff', borderRight: 0 }
                            },
                            {
                                label: i18n('Ladestrom', 'sys'), label2: '€/kWh',
                                customStyleColumn: { borderLeft: 0, ...stCl2 },
                                customStyleLabel: { ...stla },
                                customStyleLabel2: {
                                    borderLeft: '1pt solid white', borderTop: '1pt solid #fff'
                                }
                            },
                            { label: i18n('Gesamt', 'sys'), label2: `€ (${i18n('netto', 'sys')})`, customStyleLabel2: { borderTop: '1pt solid #fff' } }
                        ]
                    },
                    {
                        label: i18n('CO₂-Emissionen', 'sys'),
                        width: `${baseWidth * 1.5}%`,
                        columns: [
                            { label2: 't' }
                        ]
                    }
                ]
            },
            rows: values.rows,
            rows_width: [, , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , baseWidth * 1.5],
            row_classes: [
                'row_field_header', , , , , , , , , , , , , , 'row_field_dark', , 'row_field_dark', , 'row_field_dark', , 'row_field_dark', ,
                'row_field_dark', , 'row_field_dark', , 'row_field_dark', , 'row_field_dark', , 'row_field_dark', 'row_field_dark'
            ],
            custom_row_classes: values.custom_row_classes,
            row_web_forced: values.row_web_forced,
            diagrams: [
                {
                    title: `${i18n('Kraftstoffverbrauch', 'sys')}${!this.disableKosten ? ` & ${i18n('Entwicklung der Kosten', 'sys')}` : ''}`,
                    titlePdf: `${i18n('Kraftstoffverbrauch', 'sys')}${!this.disableKosten ? ` & ${i18n('Entwicklung der Kosten', 'sys')}` : ''}`,
                    legend: [`${i18n('Kraftstoffverbrauch', 'sys')} [kWh]`, ...(!this.disableKosten ? [`${i18n('Kraftstoffkosten', 'sys')} [€]`] : [])],
                    unit: ['kWh', ...(!this.disableKosten ? ['€'] : [])],
                    X_dataKey: 'jahr',
                    Y_dataKey: ['verbrauch', ...(!this.disableKosten ? ['kosten'] : [])],
                    data: values.diag1,
                    tickPeriod: [50, ...(!this.disableKosten ? [50] : [])],
                    singleYAxis: false,
                    lineColor,
                    containerSize: { width: '90%' }
                },
                {
                    title: i18n('Kraftstoffbedingte CO₂-Emissionen', 'sys'),
                    titlePdf: i18n('Kraftstoffbedingte CO₂-Emissionen', 'sys'),
                    legend: [`${i18n('CO₂-Emissionen', 'sys')} [t]`],
                    unit: ['t'],
                    X_dataKey: 'jahr',
                    Y_dataKey: ['emissionen'],
                    data: values.diag2,
                    tickPeriod: [5, 5],
                    singleYAxis: true,
                    lineColor,
                    containerSize: { width: '90%' }
                }
            ]
        };
        if (this.disableKosten) {
            config.header.blocks.splice(2, 1); // Kraftstoffverbrauch (Kosten)
            config.rows_width.splice(15, 17);
            config.row_classes.splice(15, 17);
        } else {
            // Zuerst die hinteren Columns
            if (!has_ladestrom) {
                config.header.blocks[2].columns.splice(14, 2);
                config.rows_width.splice(29, 2);
                config.row_classes.splice(29, 2);
            }
            if (!has_erdgas) {
                config.header.blocks[2].columns.splice(12, 2);
                config.rows_width.splice(27, 2);
                config.row_classes.splice(27, 2);
            }
            if (!has_wasserstoff) {
                config.header.blocks[2].columns.splice(10, 2);
                config.rows_width.splice(25, 2);
                config.row_classes.splice(25, 2);
            }
            if (!has_bioethanol) {
                config.header.blocks[2].columns.splice(8, 2);
                config.rows_width.splice(23, 2);
                config.row_classes.splice(23, 2);
            }
            if (!has_biodiesel) {
                config.header.blocks[2].columns.splice(6, 2);
                config.rows_width.splice(21, 2);
                config.row_classes.splice(21, 2);
            }
            if (!has_lpg) {
                config.header.blocks[2].columns.splice(4, 2);
                config.rows_width.splice(19, 2);
                config.row_classes.splice(19, 2);
            }
        }
        // Dann die vorderen Columns
        if (!has_ladestrom) {
            config.header.blocks[1].columns.splice(12, 1);
            config.rows_width.splice(13, 1);
            config.row_classes.splice(13, 1);
        }
        if (!has_erdgas) {
            config.header.blocks[1].columns.splice(11, 1);
            config.rows_width.splice(12, 1);
            config.row_classes.splice(12, 1);
        }
        if (!has_wasserstoff) {
            config.header.blocks[1].columns.splice(10, 1);
            config.rows_width.splice(11, 1);
            config.row_classes.splice(11, 1);
        }
        if (!has_bioethanol) {
            config.header.blocks[1].columns.splice(8, 2);
            config.rows_width.splice(9, 2);
            config.row_classes.splice(9, 2);
        }
        if (!has_biodiesel) {
            config.header.blocks[1].columns.splice(6, 2);
            config.rows_width.splice(7, 2);
            config.row_classes.splice(7, 2);
        }
        if (!has_lpg) {
            config.header.blocks[1].columns.splice(4, 2);
            config.rows_width.splice(5, 2);
            config.row_classes.splice(5, 2);
        }
        const helpIcon = (
            <WHelpIcon
                data={this.props.data}
                styleDivProps={{ display: 'inline-block' }}
                styleProps={{ width: 18, height: 18, borderRadius: 10, backgroundColor: '#b9cde5', verticalAlign: 'top', margin: 0 }}
                label='Datenauswertung - Hinweise'
                helpKey='datenauswertung_kraftstoffe'
                type='info'
                editBar
            />
        );

        const jahresauswahl: any = <DatenauswertungJahrauswahl
            jahrMin={this.state.jahrMin}
            jahrMax={this.state.jahrMax}
            jahrFirst={this.state.firstJahr}
            jahrLast={this.state.lastJahr}
            contextKey='datenauswertung'
            onFirstJahrChange={(jahr: number) => this.setState({ firstJahr: jahr })}
            onLastJahrChange={(jahr: number) => this.setState({ lastJahr: jahr })}
            renderClean={true}
            wrapClass={datenauswertungStyle.datenauswertungFormField}

        />;
        const arr_header_form_elements: any[] = [
            {
                elem: jahresauswahl,
                wrapClass: 'datenauswertungContentLeft',
                skipFormFieldWrapper: true
            },
            {   elem: isVeranstaltung(this.props.data, this.props.standortTid) ? this.renderVeranstaltung() : this.renderStandort(),
                wrapClass: 'datenauswertungContentGrow'
            },
            { elem: <span className={datenauswertungStyle.datenauswertungArrow}>🡆</span>, wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>{i18n('Optionen', 'sys')}</label>{this.renderEingabeButton()}</>, wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>&nbsp;</label>{this.renderBemerkungButton()}</>, wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>&nbsp;</label>{this.state.renderButton}</>, wrapClass: 'datenauswertungContentRight' },
        ];

        return (
            <div>
                {!this.props.setJSXdirect &&
                    <div className={datenauswertungStyle.datenauswertungOuterFormContainer}>
                        {/*<DatenauswertungJahrauswahl
                            jahrMin={this.state.jahrMin}
                            jahrMax={this.state.jahrMax}
                            jahrFirst={this.state.firstJahr}
                            jahrLast={this.state.lastJahr}
                            contextKey='datenauswertung'
                            externalHeaderElements={[this.renderEingabeButton(), this.renderBemerkungButton(), this.state.renderButton]}
                            onFirstJahrChange={(jahr: number) => this.setState({ firstJahr: jahr })}
                            onLastJahrChange={(jahr: number) => this.setState({ lastJahr: jahr })}
                        />
                        <div style={{ padding: 5, paddingRight: 20 }}>{helpIcon}</div>
                        */}
                        <DatenauswertungFormWrapper
                            elements={arr_header_form_elements}
                        />
                    </div>
                }
                <DatenauswertungGenerisch
                    config={config}
                    orientation='landscape'
                    setRenderButton={(renderButton: JSX.Element) => this.setState({ renderButton })}
                    setJSXdirect={this.props.setJSXdirect}
                    callbackPages={typeof this.props.callbackPages === 'function' ? this.props.callbackPages : null}
                    pdfButtonStyle={{ backgroundColor: '#686868', color: '#fff' }} 
                />
            </div>
        );
    }

    renderBemerkungButton(): JSX.Element {
        return (
            <DatenauswertungReportKonfigurationBemerkungButton
                data={this.props.data}
                standort={this.props.standortTid}
                type='kraftstoffe'
                styleProps={{ backgroundColor: '#686868', color: '#fff' }}
                noLabel={true}
            />
        );
    }

    renderEingabeButton(): JSX.Element {
        const entities: string[] = this.entities.map((item: any) => item.entity);
        return (
            <WActionButton
                label={i18n('Dateneingabe', 'sys')}
                insideText={i18n('zur E-Tool Eingabe wechseln', 'sys')}
                tooltip={i18n('zur E-Tool Eingabe wechseln', 'sys')}
                key='dateneingabe'
                action='editNote'
                styleProps={{ color: 'var(--color-button-text)', backgroundColor: 'var(--color-section-main)' }}
                onAction={() => this.props.onRoutingChange({
                    ...(getRoutingEnergiedaten(this.props.data, this.props.standortTid, entities) || {})
                })}
            />
        );
    }

    renderKennzahlenInfo(value: string, jahr: number, key: string, field: string): JSX.Element | string {
        if (value.trim() === '') {
            return null;
        }
        // return !!this.devFeaturesMap.N131_KENNZAHLEN_BERECHNUNG && (this.apiService.isAdmin() || this.apiService.isBerater())
        return true
            ? <KennzahlenInfo
                data={this.props.data}
                data-text={value}
                id={`${key}_${field}_${jahr}`}
                key={`${key}_${field}_${jahr}`}
                keyValue={`${key}_${field}`}
                jahr={jahr}
                standort={this.props.standortTid || 'ALL'}
            />
            : value;
    }

    renderStandort(): JSX.Element {
        const disabled: boolean = this.props.data.MODUL_SELECTED === 'steuer';

        return (
            <StandortAuswahl
                label={i18n('Standort', 'sys')}
                data={this.props.data}
                standort={this.props.standortTid}
                disabled={disabled}
                filter={(standort: any, callback: (visible: boolean) => void) => {
                    const kennzahlen: any = (this.props.data[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {})[standort.tid]
                        || this.props.data[IDs.KENNZIFFERN_BERECHNET] || {};
                    const flags: any = kennzahlen.flags || {};

                    if (typeof callback === 'function') {
                        callback(!!flags.hasKraftstoffe);
                    }
                }}
                onStandortChange={(standort: number) => {
                    const basisRouting: any = RoutingIDs.ROUTE_DATENAUSWERTUNG_STANDORTE;
                    const basisTab: string = RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE;
                    const tabRoutings: any[] = getStandorteGruppenTabRoutings(this.props.data, basisRouting, basisTab, 2);
                    const path: any = (tabRoutings.find((item: any) => item?.dataRow?.tid === standort) || {}).path || {};
                    this.props.onRoutingChange({ path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_KRAFTSTOFFE, ...path } });
                }}
                renderClean
            />
        );
    }

    renderVeranstaltung(): JSX.Element {
        return <>
            <label>{i18n('Standort', 'sys')}</label>
            <input type='text' value={this.props.standortName} disabled />
        </>;
    }
}
